import { render, staticRenderFns } from "./MetaDataUploader.vue?vue&type=template&id=0bc35940&scoped=true&"
import script from "./MetaDataUploader.vue?vue&type=script&lang=js&"
export * from "./MetaDataUploader.vue?vue&type=script&lang=js&"
import style0 from "./MetaDataUploader.vue?vue&type=style&index=0&id=0bc35940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc35940",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
